"use client";

import { usePathname } from "next/navigation";
import { stegaClean } from "@sanity/client/stega";
import { GROQCTA, IVideoPopup } from "@/sanity/lib/definitions";
import { IPageLink, resolveCTA, resolvePageLink } from "@/sanity/globals/CTA";
import { IPopup } from "@/sanity/globals/Popups";
import {
  resolveI18nText,
  NON_DEFAULT_LANGUAGES,
  DEFAULT_LANGUAGE,
} from "@/sanity/globals/I18n";

export function useCTAWrapper(cta: GROQCTA | null | undefined) {
  const pathname = usePathname();
  const firstSegment = pathname.split("/").filter(Boolean)[0] ?? "";
  const currentLanguage = NON_DEFAULT_LANGUAGES.includes(firstSegment)
    ? firstSegment
    : DEFAULT_LANGUAGE;

  const cleanedCta = (stegaClean(cta ?? null) ?? null) as GROQCTA | null;

  const action = cleanedCta?.action ?? null;
  const actionData = resolveCTA(cleanedCta ?? null);

  const isLink = action === "link" && actionData;
  const link = isLink
    ? resolvePageLink(actionData as IPageLink | null, currentLanguage)
    : null;
  const linkData = isLink ? (actionData as IPageLink) : null;

  const isAnchor = action === "anchor" && actionData;
  const anchor = isAnchor ? (actionData as string) : null;

  const isPopup = action === "popup" && actionData;
  const popup = isPopup ? (actionData as IPopup) : null;

  const isVideoPopup = action === "videoPopup" && actionData;
  const videoPopup = isVideoPopup ? (actionData as IVideoPopup) : null;

  const title = resolveI18nText(cta?.title, cta?.titleI18n, currentLanguage);

  return {
    action,
    isLink,
    link,
    linkData,
    isAnchor,
    anchor,
    isPopup,
    popup,
    isVideoPopup,
    videoPopup,
    title,
  };
}
